// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1cJU1","inputWrap":"CustomTip_inputWrap__1yt9h"};